import { getClassLevel } from './classIdentity.mjs';
import { isIncapacitated } from './barbarianRage.mjs';

// Revised 2024 Rogue features from level 11 on that are rules rather than resources.
export const ELUSIVE_LEVEL = 18;

/**
 * Elusive (Rogue 18): no attack roll has Advantage against the Rogue unless the Rogue has the Incapacitated condition
 * (Unconscious, Paralyzed, Stunned and Petrified include it). `targetId` is the Rogue's combatant id, for conditions
 * stored as combat effects.
 */
export const hasElusive = (character, combat = {}, targetId) => getClassLevel(character, 'rogue') >= ELUSIVE_LEVEL
  && !isIncapacitated(targetId ? { ...character, combatantId: targetId } : character, combat);

// Stroke of Luck (Rogue 20): when you fail a D20 Test, you can turn the roll into a 20. Once per Short or Long Rest.
export const STROKE_OF_LUCK_LEVEL = 20;
export const STROKE_OF_LUCK_FEATURE_ID = 'rogue:stroke-of-luck';
export const strokeOfLuckState = (character) => character?.classState?.rogue?.strokeOfLuck || { used: false };
export const canUseStrokeOfLuck = (character) => getClassLevel(character, 'rogue') >= STROKE_OF_LUCK_LEVEL && !strokeOfLuckState(character).used;
/** The rest reset, or null when there is nothing to restore. Both Short and Long Rests return it. */
export const strokeOfLuckRestState = (character) => (getClassLevel(character, 'rogue') >= STROKE_OF_LUCK_LEVEL && strokeOfLuckState(character).used ? { used: false } : null);
/** A prompt offering Stroke of Luck after a failed D20 Test (`what` names the roll, e.g. "attack roll"). */
export const strokeOfLuckDecision = (resolutionId, what, outcome) => ({
  id: `${resolutionId}:${STROKE_OF_LUCK_FEATURE_ID}`, featureId: STROKE_OF_LUCK_FEATURE_ID, title: 'Stroke of Luck',
  prompt: `Your ${what} failed. Turn the d20 into a 20${outcome ? ` (${outcome})` : ''}? You can't use this again until you finish a Short or Long Rest.`,
  choices: [{ id: 'use', label: 'Make it a 20', action: 'apply' }, { id: 'skip', label: 'Keep the roll' }],
});
